/**
 * Authenticated Page decorator script class
 *
 * @package    Decorators
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import { aclDecorator } from 'Decorators';

export default (allowedRoles = null) => WrappedComponent => {
    @aclDecorator()
    @connect(store => ({
        isLoggedIn: store.auth.isLoggedIn,
        user: store.auth.user,
    }))
    class AuthenticatedPageDecorator extends PureComponent {
        /**
         * @type {Object}
         */
        static propTypes = {
            location: PropTypes.any,
            history: PropTypes.any,
            user: PropTypes.object,
            isLoggedIn: PropTypes.bool.isRequired,
            is: PropTypes.func.isRequired,
            isNot: PropTypes.func.isRequired,
            isOneOf: PropTypes.func.isRequired,
            isNotOneOf: PropTypes.func.isRequired,
        };

        /**
         * @type {Object}
         */
        static contextTypes = {
            intl: PropTypes.object.isRequired,
        };

        /**
         * Check is user authenticated on mount
         */
        componentDidMount() {
            this.checkAuth();
        }

        /**
         * Check is user authenticated on location change
         *
         * @param {Object} prevProps
         */
        componentDidUpdate(prevProps) {
            if (
                prevProps.location.pathname !== this.props.location.pathname ||
                prevProps.isLoggedIn !== this.props.isLoggedIn
            ) {
                this.checkAuth();
            }
        }

        /**
         * Redirect user to home page if user is not authenticated
         */
        checkAuth = () => {
            const { isLoggedIn, isNotOneOf } = this.props;

            if (!isLoggedIn) {
                this.redirect();
            } else {
                if (allowedRoles) {
                    if (isNotOneOf(allowedRoles)) {
                        this.redirect('alert.forbidden');
                    }
                }
            }
        };

        /**
         * Redirect user to home page
         *
         * @param {String} message
         * @param {String} to
         */
        redirect = (message = null, to = '/login') => {
            const { history, location: { pathname } } = this.props;

            history.replace({
                pathname: to,
                state: {
                    from: pathname,
                },
            });
            if (message) {
                toastr.error(this.context.intl.formatMessage({ id: message }), { timeOut: 20000 });
            }
        };

        render() {
            const { is, isNot, isOneOf, isNotOneOf, isLoggedIn } = this.props;

            if (!isLoggedIn) {
                return <div className="container-fluid" />;
            }

            return <WrappedComponent {...this.props} is={is} isNot={isNot} isOneOf={isOneOf} isNotOneOf={isNotOneOf} />;
        }
    }

    return AuthenticatedPageDecorator;
};



// WEBPACK FOOTER //
// ./src/decorators/authenticatedPageDecorator.jsx